import { render, staticRenderFns } from "./MobileHome.vue?vue&type=template&id=4277bea4"
import script from "./MobileHome.vue?vue&type=script&lang=js"
export * from "./MobileHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4277bea4')) {
      api.createRecord('4277bea4', component.options)
    } else {
      api.reload('4277bea4', component.options)
    }
    module.hot.accept("./MobileHome.vue?vue&type=template&id=4277bea4", function () {
      api.rerender('4277bea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/MobileHome.vue"
export default component.exports